import React, { useState, useEffect } from 'react';
import { ChevronDown, UserRound } from 'lucide-react';
import FixedActionBar from '../menus/FixedActionBar.js';

import ProductCard from '../components/ProductCard.js';
import AudioPlayer from '../components/AudioPlayer.js';
import Reassurance from '../components/Reassurance.js';
import CustomerReviews from '../components/CustomerReviews.js';
// import ComparisonFunctionsTable from '../components/ComparisonFunctionsTable.js';
import { AudioLinesIcon } from 'lucide-react';
import Loader from '../components/Loader.js';
import { useParams, useNavigate  } from 'react-router-dom';

import { Link } from "react-router-dom";
import VideoBanner from '../components/VideoBanner.js';

import { stripeProductsAPI, stripeProductPricesAPI } from '../apis/apiStripe.js';

import '../styles/ProductPage.css'
import CountdownTimer from '../components/CountdownTimer.js';

function B01LiteProductPage() {
  const [B01Lite, setB01Lite] = useState({});
  const [loader, setLoader] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { color } = useParams();
  const navigate = useNavigate();

  // Données des sections pour l’accordéon
  const accordionData = [
    {
      title: 'Sans abonnement',
      content: (
        <>
          <p>
            Le B01Lite fonctionne sans besoin d’abonnement supplémentaire.
            Il suffit simplement de disposer d’un smartphone avec l’application Baltee installée
            pour profiter de toutes les fonctionnalités du dispositif.
            L’application permet de gérer les alertes, les notifications de sécurité
            et le suivi en temps réel, directement via votre téléphone.
          </p>
        </>
      )
    },
    {
      title: 'Résistant',
      content: (
        <>
          <p>
            Le B01Lite de Baltee est conçu pour résister aux éléments,
            offrant une protection optimale contre l’eau et la poussière.
          </p>
          <p>
            <strong>Indice de protection :</strong> IP66
          </p>
        </>
      )
    },
    {
      title: 'Robuste',
      content: (
        <>
          <p>
            Le B01Lite affiche une robustesse exceptionnelle,
            notamment grâce à son cercle en aluminium qui l’entoure,
            ajoutant une couche supplémentaire de protection contre les chocs.
          </p>
        </>
      )
    },
    {
      title: 'Élégant et discret',
      content: (
        <>
          <p>
            Le B01Lite se distingue par son design compact et discret,
            conçu spécifiquement pour s’intégrer parfaitement sur le guidon de votre vélo.
          </p>
          <p>
            <strong>Dimension du B01Lite seul : </strong>86&nbsp;mm × 46&nbsp;mm × 15&nbsp;mm<br/>
            <strong>Dimension du B01Lite + SMARTFIX : </strong>86&nbsp;mm × 46&nbsp;mm × 62&nbsp;mm
          </p>
        </>
      )
    },
    {
      title: 'Endurant',
      content: (
        <>
          <p>
            Capable de fonctionner jusqu’à une semaine<em>*</em> sur une seule charge.
            Recharge via USB-C en toute simplicité.
          </p>
          <p>
            <em>*En fonction de son utilisation.</em>
          </p>
        </>
      )
    },
    {
      title: 'Léger',
      content: (
        <>
          <p>
            Le B01Lite est remarquablement léger, conçu pour garantir que son ajout sur le guidon
            de votre vélo ou trottinette ne modifie pas l’équilibre
            ni la maniabilité de votre monture.
          </p>
          <p>
            <strong>Poids du B01Lite seul : </strong>70&nbsp;g<br/>
            <strong>Poids du B01Lite + SMARTFIX : </strong>95&nbsp;g
          </p>
        </>
      )
    }
  ];

  const accordionData2 = [
    {
      title: 'Alarme antivol',
      content: (
        <>
          <p>
            L'alarme antivol du B01Lite offre une sécurité renforcée grâce à une technologie
            avancée combinée à une facilité d'utilisation. Elle peut être activée ou
            désactivée via une application mobile ou directement sur le B01Lite grâce à
            un code personnalisé (combinaison d'appuis sur les boutons de votre B01Lite).
          </p>
          <p>
            Son système de détection de mouvement hautement sensible distingue les vibrations
            accidentelles des tentatives de vol, déclenchant un signal sonore puissant (~100dB)
            pour dissuader les voleurs.
          </p>
        </>
      )
    },
    {
      title: 'Détecteur de chute',
      content: (
        <>
          <p>
            Au cœur du détecteur de chute se trouve un système de capteurs sophistiqués,
            incluant un accéléromètre et un gyroscope, qui surveillent en continu
            les mouvements du vélo. Ces capteurs sont capables de distinguer une chute
            ou un renversement soudain du vélo des mouvements normaux de cyclisme,
            permettant ainsi une détection précise et fiable des incidents.
          </p>
          <p>
            En cas de détection d'une chute, le dispositif déclenche automatiquement
            une procédure d'alerte. Un signal sonore et visuel peut être activé pour
            attirer l'attention des passants et demander une assistance immédiate.
            Parallèlement, le B01Lite envoie une notification d'urgence via l'application
            mobile associée au dispositif.
          </p>
        </>
      )
    },
    {
      title: "Bouton SOS",
      content: (
        <>
          <p>
            Le bouton SOS est conçu pour offrir un moyen direct et immédiat de
            signaler une situation d'urgence. Situé de manière ergonomique sur le B01Lite,
            ce bouton peut être activé facilement et discrètement, permettant aux utilisateurs
            de demander de l'aide sans attirer l'attention indésirable ou sans avoir
            à manipuler d'autres dispositifs.
          </p>
          <p>
            L'utilisateur peut déclencher une alarme sonore s'il le souhaite en appuyant
            sur le bouton d'urgence une seconde fois afin de prévenir et d'alerter les
            personnes à proximité en cas de malaise ou d'agression. Lorsque le bouton
            SOS est pressé, le B01Lite envoie automatiquement une alerte à une liste prédéfinie
            de contacts d'urgence via l'application mobile associée. Cette alerte comprend
            la position GPS exacte du cycliste, facilitant une intervention rapide et
            ciblée.
          </p>
        </>
      )
    },
    {
      title: 'Avertisseur sonore',
      content: (
        <>
          <p>
            Le double avertisseur sonore du B01Lite est conçu pour offrir aux cyclistes
            un moyen efficace de signaler leur présence aux autres usagers de la route,
            réduisant ainsi le risque de collisions. Cette caractéristique unique permet
            d'émettre deux types de signaux sonores distincts, adaptés à différentes
            situations de trafic.
          </p>
          <p>
            • <strong>Signal d'Alerte</strong> : Un son court de type sonnette, idéal pour attirer
            rapidement l'attention des piétons ou des autres cyclistes en cas de besoin immédiat.
            <br />
            • <strong>Signal de Prévention</strong> : Un son plus fort conçu pour avertir
            les véhicules motorisés de l'approche d'un cycliste, particulièrement utile
            lors de changements de voie ou dans les angles morts.
          </p>
        </>
      )
    }
  ];
  

  // État pour savoir quel item est ouvert, -1 = aucun
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleAccordion = (index) => {
    // Si on reclique sur l’item déjà ouvert, on le referme
    // Sinon on ouvre l’item cliqué
    setOpenIndex(openIndex === index ? -1 : index);
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsResponse = await stripeProductsAPI();
  
        if (!productsResponse || !productsResponse.data) {
          return console.warn("Aucun produit trouvé.");
        }
  
        const activeProducts = productsResponse.data.filter(product => product.active);
  
        const formattedProducts = await Promise.all(
          activeProducts.map(async (product) => {
            const priceData = product.default_price
              ? await stripeProductPricesAPI(product.id)
              : null;
  
            return {
              productId: product.id,
              name: product.name,
              description: product.description,
              image: product.images?.[0] || null,
              metadata: product.metadata,
              created: product.created,
              updated: product.updated,
              price: priceData,
            };
          })
        );
  
        const filterActivePrices = (product) => ({
          ...product,
          price: {
            ...product.price,
            data: product.price?.data?.filter(price => price.active) || []
          }
        });
  
        const productsWithActivePrices = formattedProducts.map(filterActivePrices);
  
        const filteredProductsB01Lite = productsWithActivePrices.filter(
          product => product.metadata.ref === "B01LITE"
        );
  
        const ProductsB01Lite = { bgVideo: '/assets/backgrounds/videos/bg-5.mp4', data: filteredProductsB01Lite };
        setB01Lite(ProductsB01Lite);
  
        // Lecture de la couleur via le hash de l’URL (ex: #ddd1bc)
        const hashColor = window.location.hash ? window.location.hash.toUpperCase() : null;
  
        let defaultProduct;
  
        // Priorité : hex via hash, puis color via paramètre
        if (hashColor) {
          defaultProduct = filteredProductsB01Lite.find(
            (product) => product.metadata.color?.toUpperCase() === hashColor
          );
        }
  
        if (!defaultProduct && color) {
          defaultProduct = filteredProductsB01Lite.find(
            (product) => product.metadata.color === color
          );
        }
  
        setSelectedProduct(defaultProduct || filteredProductsB01Lite[1]);
        setLoader(false);
      } catch (error) {
        console.error("Erreur lors de la récupération des produits Stripe :", error);
      }
    };
  
    fetchProducts();
  }, [color]);
  

  const handleProductSelected = (product) => {
    setSelectedProduct(product);
    navigate(`/product/boitier-multifonction-securite-velo-trottinette-b01-lite/${product.metadata.color}`);
  };

  return (
    <div className='product-page' style={{margin: "0 auto" }}>

      {/* {selectedProduct?.metadata.promo_date ? <div style={{backgroundColor: "#bbe2d2", marginTop: "-4px", position: 'fixed', width: '100%', zIndex: 99}}><CountdownTimer color="black" date={selectedProduct?.metadata.promo_date}/></div> : null} */}

      <div style={{maxWidth: "1200px", margin: "0 auto" }}>
        {
          !loader ?
            <div style={{ paddingTop: 10 }}>
              
              <div className='desktop-block-2'>
                <div>
                  <div className='mobile'>
                    { B01Lite.data && B01Lite.bgVideo ? <ProductCard products={B01Lite} discover={false} actions={true} onProductSelected={handleProductSelected} forcedColor={selectedProduct?.metadata?.color}  backgroundVideoEnabled={false} modeColor="blue" /> : <Loader /> }
                  </div>
                  <div className='desktop'>
                    { B01Lite.data && B01Lite.bgVideo ? <ProductCard products={B01Lite} discover={false} actions={true} onProductSelected={handleProductSelected} forcedColor={selectedProduct?.metadata?.color}  backgroundVideoEnabled={false} modeColor="blue" /> : <Loader /> }
                  </div>
                </div>

                <div>
                <h1 style={{fontSize: 55, textTransform: 'uppercase', marginLeft: '2%', marginRight: '2%'}}>Le B01, sans le rétro éclairage des boutons</h1>
                
                <div className='mobile'>
                  <VideoBanner source="/assets/videos/AF_B01Lite_5.mp4" setAutoPlay={true} />
                </div>

                <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Fonctionnalités</p>

                <div style={{ borderRadius: 28, padding: '20px', margin: '20px', backgroundColor: '#fff' }}>
                  {accordionData2.map((item, index) => (
                    <div key={index} style={{ marginBottom: '10px' }}>
                      <button
                        onClick={() => toggleAccordion(index)}
                        style={{
                          width: '100%',
                          textAlign: 'left',
                          padding: '10px',
                          fontSize: '16px',
                          backgroundColor: '#fff',
                          border: '1px solid #ddd',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          borderRadius: 28,
                          color: '#333'
                        }}
                      >
                        <span>{item.title}</span>
                        <ChevronDown
                          size={20}
                          style={{
                            transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease'
                          }}
                        />
                      </button>

                      <div
                        style={{
                          maxHeight: openIndex === index ? '500px' : '0px',
                          overflow: 'hidden',
                          transition: 'max-height 0.3s ease',
                          borderTop: 'none',
                          padding: openIndex === index ? '10px' : '0 10px',
                          backgroundColor: '#fff'
                        }}
                      >
                        {item.content}
                      </div>
                    </div>
                  ))}
                </div>

                <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Avantages</p>

                {/* Accordéon */}
                <div style={{ borderRadius: 28, padding: '20px', margin: '20px', backgroundColor: '#fff' }}>
                  {accordionData.map((item, index) => (
                    <div key={index} style={{ marginBottom: '10px' }}>
                      {/* Bouton d’en-tête de l’accordéon */}
                      <button
                        onClick={() => toggleAccordion(index)}
                        style={{
                          width: '100%',
                          textAlign: 'left',
                          padding: '10px',
                          fontSize: '16px',
                          backgroundColor: '#fff',
                          border: '1px solid #ddd',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          borderRadius: 28,
                          color: '#333'
                        }}
                      >
                        <span>{item.title}</span>
                        {/* Icône Lucide (flèche bas) + rotation */}
                        <ChevronDown
                          size={20}
                          style={{
                            transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease'
                          }}
                        />
                      </button>

                      {/* Contenu de l’accordéon (avec transition) */}
                      <div
                        style={{
                          maxHeight: openIndex === index ? '500px' : '0px',
                          overflow: 'hidden',
                          transition: 'max-height 0.3s ease',
                          borderTop: 'none',
                          padding: openIndex === index ? '10px' : '0 10px',
                          backgroundColor: '#fff'
                        }}
                      >
                        {item.content}
                      </div>
                    </div>
                  ))}
                </div>
                </div>
              </div>
{/* 
              <div className='desktop-block-3'>
                <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                  <img src="/assets/other/etanche.png" style={{maxWidth: '100%'}}  alt="B01Lite"/>
                </div>   
                <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                  <img src="/assets/other/lumineux.png" style={{maxWidth: '100%'}}  alt="B01Lite"/>
                </div> 
                <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                  <img src="/assets/other/lege.png" style={{maxWidth: '100%'}}  alt="B01Lite"/>
                </div> 
              </div> */}

              <Reassurance /> 

              <CustomerReviews />
              
              <div className='desktop-block-2'>
                <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                  <img src="/assets/products/B01_3-4_R.png" style={{maxWidth: '100%'}} alt="B01Lite"/>
                </div> 
                <div>
                  <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Application mobile</p>

                  <div style={{ borderRadius: 28, padding: '20px', margin: '20px', backgroundColor: '#fff' }}>
                    <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                      <img src="/assets/other/app.png" style={{maxWidth: '100%'}}  alt="B01Lite"/>
                    </div>  
                    <p>
                    Le B01Lite doit être connecté à l’application Baltee via votre smartphone pour envoyer les alertes SMS et e-mail.
                    <br />
                    L’application permet de configurer votre B01Lite selon vos besoins
                    <br />
                    Définissez vos contacts d’urgence directement depuis l’application
                    <br />
                    Recevez des notifications en temps réel et assurez votre sécurité en cas de chute ou d’urgence
                    </p>
                    <p><strong>Disponible sur iOS & Android :</strong> <br />
                    Téléchargez Baltee gratuitement sur l’<a target='_blank' href="https://apps.apple.com/fr/app/baltee/id6499310232" rel="noopener noreferrer">App Store</a> et <a target='_blank' href="https://play.google.com/store/apps/details?id=com.baltee.baltee" rel="noopener noreferrer">Google Play</a> pour profiter pleinement des fonctionnalités de votre B01Lite.</p>
                  </div>
                </div>
              </div> 

              <div className='desktop-block-2'>
                <div>
                  <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Smartfix</p>

                  <div style={{ borderRadius: 28, padding: '20px', margin: '20px', backgroundColor: '#fff' }}>
                    <p>
                    Le système Smartfix breveté permet une fixation rapide, sécurisée et sans outils du B01Lite sur n'importe quel guidon standard, assurant une stabilité optimale tout en facilitant le montage et le démontage en un quart de tour. Seulement vous pouvez retirer votre B01Lite de son support en un clin d'œil en déverrouillant la Smartfix via l'application mobile Baltee. 
                    </p>
                    <ul>
                      <li>Poids : 25 g</li>
                      <li>Diamètre intérieur : 22mm</li>
                      <li>Couleurs disponibles : Green, Black</li>
                    </ul>
                    <video autoPlay loop muted playsInline style={{width: '100%', borderRadius: 28}}>
                      <source src="/assets/videos/fix.mp4" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>

                <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                  <video autoPlay loop muted playsInline style={{width: '100%'}}>
                    <source src="/assets/videos/arnaud.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div> 
              </div>
                
              <div className='desktop-block-2'>
                <div>
                  <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Contact d'urgence ?</p>

                  <div style={{ borderRadius: 28, padding: '20px', margin: '20px', backgroundColor: '#fff' }}>
                    <UserRound size={50} color='#333'/>
                    <UserRound size={50} color='#333'/>
                    <UserRound size={50} color='#333'/>
                    <p>
                    Les contacts d’urgence du B01Lite sont gérés directement depuis l’application Baltee. Vous pouvez ajouter plusieurs proches qui seront immédiatement alertés par SMS et e-mail en cas d’incident (chute, alerte SOS). Cette fonctionnalité permet une intervention rapide et rassure vos proches en leur fournissant votre position GPS en temps réel.
                    </p>
                  </div>
                </div>
                <div>
                  <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Alertes <small>(E-mail, SMS)</small></p>

                  <div style={{ borderRadius: 28, padding: '20px', margin: '20px', backgroundColor: '#fff' }}>
                    <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                      <img src="/assets/other/alerte.png" style={{maxWidth: '100%'}}  alt="B01Lite"/>
                    </div>  
                    <p>
                    Les alertes par e-mail et SMS du B01Lite permettent une réactivité optimale en cas d’événement critique. Lorsqu’une chute, ou un déclenchement du bouton SOS sont détectée alors, le B01Lite envoie immédiatement un email et un sms à vos contacts d'urgence préenregistrés via l'application mobile Baltee.
                    </p>
                  </div>
                </div>
              </div>

              <div className='desktop-block-2'>
                
                <div>
                  <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Configuration</p>

                  <div style={{ borderRadius: 28, padding: '20px', margin: '20px', backgroundColor: '#fff' }}>
                    <p>Simple et rapide, installer votre B01Lite en moins de 2 minutes !<br /><br />
                    - Téléchargez l'application et inscrivez-vous ou connectez-vous.<br />
                    - Ajoutez votre produit et suivez l'initialisation.<br />
                    - Ajoutez votre premier contact d'urgence.<br />
                    - Nommez votre produit et définissez un code antivol.<br />
                    - Activez les fonctionnalités et c'est parti, votre B01Lite est prêt à l'emploi !
                    </p>
                    <br />
                    <video autoPlay loop muted playsInline style={{width: '100%', borderRadius: 28}}>
                    <source src="/assets/videos/instalB01Lite_2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  </div> 
                </div>  
                <div>
                  <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Notices</p>

                  <div style={{ borderRadius: 28, padding: '20px', margin: '20px', backgroundColor: '#fff' }}>
                    <p>Des notices digitales pour un avenir plus vert !</p>
                    <p>
                    Chez Baltee, nous avons choisi de remplacer les notices papier par des versions digitales afin de préserver l’environnement. Moins de papier, moins de déchets et une expérience plus interactive pour vous !
                    </p>
                    <p>Découvrez nos notices digitales en cliquant ci-dessous.</p>
                    <p style={{textAlign: 'right'}}><Link to="/qr/notices-utilisation/b01-lite">Notice B01Lite {'>'}</Link></p>
                  </div>
                </div>
              </div>
              
              <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Sons</p>
              <div style={{ borderRadius: 28, padding: '20px', margin: '20px', backgroundColor: '#fff' }}>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}><AudioLinesIcon size={30} /> Sonnette <AudioPlayer path="/assets/sounds/bell.wav"/></div>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}><AudioLinesIcon size={30} /> Avertisseur <AudioPlayer path="/assets/sounds/klax.wav"/></div>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}><AudioLinesIcon size={30} /> Alarmes <AudioPlayer path="/assets/sounds/alarme.mp3"/></div>
              </div>

              <div className='desktop-block-2'>
                <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                  <video autoPlay loop muted playsInline style={{width: '100%'}}>
                    <source src="/assets/videos/arnaud.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div> 

                <div>
                  <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Fiche technique</p>
                  <img src="/assets/other/B01-Lite.png" alt="comparasion" className="comparasion" />
                </div>
              </div>

              <div className='desktop-block-2'>
                <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                  <img src="/assets/products/B01_3-4_R.png" style={{maxWidth: '100%'}}  alt="B01Lite"/>
                </div>   
                <div style={{margin: '40px 20px', borderRadius: 28, overflow: 'hidden'}}>
                  <img src="/assets/products/B01_S.png" style={{maxWidth: '100%'}}  alt="B01Lite"/>
                </div> 
              </div>

              <br />
            </div>
          :
            <div className="loader-container">
              <Loader />
            </div>
        }
        {B01Lite.data && <FixedActionBar product={selectedProduct} />}
      </div>
    </div>
  );
}

export default B01LiteProductPage;
